import { render, staticRenderFns } from "./more-list.vue?vue&type=template&id=30b27c36&scoped=true"
import script from "./more-list.vue?vue&type=script&lang=js"
export * from "./more-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b27c36",
  null
  
)

export default component.exports